export class PrestacaoAluno {
  public id: number;
  public codigoInscricaoAluno: number;
  public respostaQuestionario: number;
  public status: number;
  public motivoReprovacao: string;

}
